import React, { Component } from "react";
import "./createDocumentModal.css";
import "./employee.css";

import {
  uploadEmployeeRedux,
  updateEmployeeRedux,
} from "../../../actions/index";
import { connect } from "react-redux";
import { toast } from "react-toastify";
class CreateDocumentModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      address: "",
      designation: "",
      adminId: "",
      status: "",
    };
  }

  componentWillReceiveProps = (nextProps) => {
    const { employee } = nextProps;
    console.log(employee);

    if (employee != null) {
      this.setState(
        {
          name: employee.name,
          designation: employee.designation,
          address: employee.address,
          adminId: employee.adminId ? employee.adminId : "",
          status: employee.status || "",
        },
        () => {
          console.log(this.state);
        }
      );
    } else {
      this.setState({
        name: "",
        designation: "",
        address: "",
        adminId: "",
        status: "",
      });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    console.log(this.state);
    console.log(this.props.employee);
    if (this.props.employee === null) {
      await this.props.uploadEmployeeRedux({
        address: this.state.address,
        name: this.state.name.replaceAll("_", "-"),
        designation: this.state.designation,
        employeeId: this.state.name.replaceAll("_", "-"),
        adminId: this.state.adminId,
        status: this.state.status,
      });
      toast.success(`Successfully created employee ${this.state.name}`);
    } else {
      await this.props.updateEmployeeRedux({
        ...this.state,
        employeeId: this.state.name,
      });
      toast.success(`successfully updated employee ${this.state.name}`);
    }

    this.setState({
      name: "",
      address: "",
    });
    this.props.startToggleModal(null);
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
  render() {
    console.log(this.props.employee);
    return (
      <>
        <div
          className={
            this.props.toggleModal
              ? "modal fade show em-page tb-modal"
              : "modal fade show visible-modal em-page tb-modal"
          }
          id="request_popup"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered request_popup"
            role="document"
          >
            <div className="modal-content em-modal-content">
              <div className="modal-body p-0">
                <div className="em-modal-body-inner" style={{ position: "relative" }}>
                  <span
                    onClick={() => this.props.startToggleModal(null)}
                    className="em-modal-close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="icofont-close-line"></i>
                  </span>

                  <div className="em-modal-stamp em-stamp-font">
                    {!this.props.employee ? "New employee" : "Edit employee"}
                  </div>
                  <div className="em-modal-icon-chip">
                    <i className="icofont-user"></i>
                  </div>
                  <div className="em-modal-title">
                    {!this.props.employee
                      ? "Create New Employee"
                      : "Update Employee"}
                  </div>

                  <form onSubmit={this.handleSubmit} noValidate="novalidate">
                    <div className="em-field">
                      <label className="em-label">Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control em-input"
                        placeholder="Employee name"
                        onChange={this.handleChange}
                        value={this.state.name}
                        required
                        readOnly={this.props.employee ? true : false}
                      />
                    </div>
                    <div className="em-field">
                      <label className="em-label">Designation</label>
                      <input
                        type="text"
                        required
                        name="designation"
                        className="form-control em-input"
                        placeholder="Employee Designation"
                        onChange={this.handleChange}
                        value={this.state.designation}
                      />
                    </div>
                    <div className="em-field">
                      <label className="em-label">Address</label>
                      <input
                        type="text"
                        required
                        name="address"
                        className="form-control em-input"
                        placeholder="Home Address"
                        onChange={this.handleChange}
                        value={this.state.address}
                      />
                    </div>
                    <div className="em-field">
                      <label className="em-label">Status</label>
                      <select
                        title="Please choose a package"
                        required
                        name="status"
                        className="custom-select em-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.status}
                      >
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Deactive">Deactive</option>
                      </select>
                    </div>
                    <div className="em-field">
                      <label className="em-label">
                        Admin Id (attach admin for Sourcing/Purchasing)
                      </label>
                      <input
                        type="text"
                        required
                        name="adminId"
                        className="form-control em-input"
                        placeholder="Enter adminId"
                        onChange={this.handleChange}
                        value={this.state.adminId}
                      />
                    </div>

                    <div className="form-row">
                      <div
                        className="col pt-2"
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <button type="submit" className="btn em-submit-btn">
                          {this.props.employee == null
                            ? "Create Employee"
                            : "Update Employee"}
                          <i className="icofont-rounded-right"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(null, {
  uploadEmployeeRedux,
  updateEmployeeRedux,
})(CreateDocumentModal);
